/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Execute_Output7Inputs */

const en_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running automations`)
};

const ar_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أتمتات تعمل`)
};

const bn_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চলমান অটোমেশন`)
};

const de_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausführen von Automatisierungen`)
};

const es_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutando automatizaciones`)
};

const fr_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécution d'automatisations`)
};

const pt_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executando automações`)
};

const zh_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行自动化`)
};

const tr_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomasyonları çalıştırma`)
};

const ru_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск автоматизации`)
};

const pl_svc_automation_execute_output7 = /** @type {(inputs: Svc_Automation_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uruchomienie automatyzacji`)
};

/**
* | output |
* | --- |
* | "Running automations" |
*
* @param {Svc_Automation_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_execute_output7 = /** @type {((inputs?: Svc_Automation_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_execute_output7(inputs)
	if (locale === "bn") return bn_svc_automation_execute_output7(inputs)
	if (locale === "de") return de_svc_automation_execute_output7(inputs)
	if (locale === "es") return es_svc_automation_execute_output7(inputs)
	if (locale === "fr") return fr_svc_automation_execute_output7(inputs)
	if (locale === "pt") return pt_svc_automation_execute_output7(inputs)
	if (locale === "zh") return zh_svc_automation_execute_output7(inputs)
	if (locale === "tr") return tr_svc_automation_execute_output7(inputs)
	if (locale === "ru") return ru_svc_automation_execute_output7(inputs)
	if (locale === "pl") return pl_svc_automation_execute_output7(inputs)
	return en_svc_automation_execute_output7(inputs)
});
export { svc_automation_execute_output7 as "svc_automation_EXECUTE_output" }